import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import OnboardingModal from './index';
import { ONBOARDING_ROUTES } from 'constants/Routes';

const SelectSurvey = ({ path, setModalStatus }) => {
  const [isVisible, toggleModal] = useState(path === ONBOARDING_ROUTES.STEP_ONE);

  useEffect(() => {
    setModalStatus(isVisible);
  }, [isVisible]);

  const closeModal = () => {
    toggleModal(!isVisible);
    setModalStatus(false);
  }

  return (
    <OnboardingModal
      isVisible={isVisible}
      handleContinue={closeModal}
      buttonText={"Select a Survey Template"}
    >
      <h2>Welcome to Soono!</h2>
      <p>Enjoy 7 days of Soono at no cost</p>
      <hr align="left" className="subheading-divider"></hr>
      <p>
        You’re one step closer to getting to know your customers even better.{' '}
        Let us help you get acquainted with the system. You can skip guidance at any time.
      </p>
    </OnboardingModal>
  );
};

SelectSurvey.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func
};

export default SelectSurvey;



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modal/SelectSurvey.js